export const sidebarItemProps = {
  collapsed: { type: Boolean, default: false },
  activeItem: { type: String, required: true },
  canSeePage: { type: Function, required: true },
};

export function useSidebarItem(emit) {
  const navigate = (event, routeName) =>
    emit("navigate", event, routeName);

  const handleMiddleClick = (event, routeName) =>
    emit("middle-click", event, routeName);

  const showContextMenu = (event, routeName) =>
    emit("context-menu", event, routeName);

  return { navigate, handleMiddleClick, showContextMenu };
}
